// extracted by mini-css-extract-plugin
export default {"wrapper":"Tag-module--wrapper--a092a","tagBg":"Tag-module--tagBg--48c1f","content":"Tag-module--content--04c33 typography-module--label--4d85e"};